import React from 'react';
import { useLocation } from 'react-router';
import ModalWrapper from '../common/ModalWrapper';
import { PropsFromRedux } from '.';
import { API_KEYS } from '../../interfaces/api';
import goldbox from '../../assets/images/gold-box.svg';
import { FetchState } from '../../interfaces';
import { PRICE, INTL_PRICE } from '../../interfaces/shipping.interface';
import { formatMoney } from '../../utils/common.utils';
import { Spinner } from '../Spinners/Spinner';

interface Props extends PropsFromRedux {}

const PriceQuoteModal: React.FC<Props> = ({
  modal,
  getPriceState,
  getIntlPriceState,
  hideModal,
  resetApi,
}) => {
  const location = useLocation();
  const isLocal = location.pathname.includes('local');
  const priceState: FetchState = isLocal ? getPriceState : getIntlPriceState;

  const { loading, error, request } = priceState;

  React.useEffect(() => {
    if (error) {
      hideModal();
    }
    return () => {
      resetApi(API_KEYS.GET_PRICE_QUOTE);
      resetApi(API_KEYS.GET_INTL_PRICE);
    };
  }, [resetApi, error, hideModal]);

  if (loading) {
    return (
      <ModalWrapper
        hideCloseButton
        goBack
        hideModal={hideModal}
        redirectOnClose="/"
      >
        <Spinner color="#CCC" />
      </ModalWrapper>
    );
  }

  const Quantity = isLocal
    ? request?.PreShipmentItems[0]?.Quantity
    : request?.Quantity;

  const Weight = isLocal
    ? request?.PreShipmentItems[0]?.Weight
    : request?.Weight;

  const localPriceResponse: PRICE = getPriceState?.response?.Object;
  const intlPriceResponse: INTL_PRICE = getIntlPriceState?.response?.Object;

  return (
    <ModalWrapper disablePadding hideModal={hideModal}>
      <div className="text-center p-8">
        <h4 className="font-bold text-3xl mb-8">Shipment Cost Estimate</h4>
        <p className="max-w-sm mx-auto">
          This is just an estimated cost for your shipment. Actual price may
          vary after creating a shipment.
        </p>
        <img className="inline-flex" src={goldbox} alt="" />
        <div className="flex justify-around my-5">
          <span>Quantity: {Quantity}</span>
          <span>Weight: {Weight}kg</span>
        </div>
      </div>
      <div className="bg-gray-200 p-8">
        <div className="flex justify-around items-center">
          <div className="font-medium md:text-lg text-sm">Total Item Cost</div>
          {isLocal ? (
            <div className="font-bold md:text-2xl text-md">
              {formatMoney(
                localPriceResponse?.GrandTotal,
                localPriceResponse?.CurrencyCode || 'NGN'
              ).replace(
                localPriceResponse?.CurrencyCode || 'NGN',
                localPriceResponse?.CurrencySymbol || '₦'
              )}
            </div>
          ) : (
            <div className="font-bold md:text-2xl text-md">
              {formatMoney(
                intlPriceResponse?.Price,
                intlPriceResponse?.CurrencyCode || 'NGN'
              ).replace(
                intlPriceResponse?.CurrencyCode || 'NGN',
                intlPriceResponse?.CurrencySymbol || '₦'
              )}
            </div>
          )}
        </div>
      </div>
    </ModalWrapper>
  );
};

export default PriceQuoteModal;
